var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"breadcrumbs__item"},[_c('a',{staticClass:"breadcrumbs__link",class:{ active: _vm.active },attrs:{"href":_vm.link}},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }